// src/App.js
import './App.css';
import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { useAuth } from './Outer/Context/AuthContext';
import LoginPage from './Outer/Pages/LoginPage';
import ForgetPassword from './Outer/Pages/ForgetPassword';
import ChangePassword from './Outer/Pages/ChangePassword';
import MailSend from './Outer/Pages/MailSend';
import Home from './Main/Pages/Home';
import Events from './Main/Pages/Events';
import Alumni from './Main/Pages/Alumni';
import MarkdownEditor from './Main/Pages/MarkdownEditor';
import FullPageLoader from './Main/Utils/FullPageLoader';

function App() {
    const { currentUser, loading } = useAuth();

    if (loading) {
      return <FullPageLoader />;
    }

    return (
        <Router>
            <Routes>
                {currentUser ? (
                    <>
                        <Route path="/" element={<Home />} />
                        <Route path="/events" element={<Events />} />
                        <Route path="/alumni" element={<Alumni />} />
                        <Route path="/editor" element={<MarkdownEditor />} />
                        <Route path="*" element={<Navigate to="/" />} />
                    </>
                ) : (
                    <>
                        <Route path="/" element={<LoginPage />} />
                        <Route path="/forgetpassword" element={<ForgetPassword />} />
                        <Route path="/reset-password/:token" element={<ChangePassword />} />
                        <Route path="/mailsend" element={<MailSend />} />
                        <Route path="/editor" element={<MarkdownEditor />} />
                        <Route path="*" element={<Navigate to="/" />} />
                    </>
                )}
            </Routes>
        </Router>
    );
}

export default App;
